var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/RoutedBreadcrumb.tsx
import * as React from "react";
import { Breadcrumbs as MinBreadcrumbs, Link } from "@mineral/core";
var parseURLRoute = (urlpath, globalLookup, localLookup, homeBreadcrumbLabel) => {
  const defaultPath = { path: "/", name: homeBreadcrumbLabel };
  const urlList = [];
  urlList.push(defaultPath);
  if (!urlpath || urlpath === "/") {
    return urlList;
  }
  if (!urlpath.endsWith("/")) {
    urlpath = `${urlpath}/`;
  }
  if (!urlpath.startsWith("/")) {
    urlpath = `/${urlpath}`;
  }
  let resultMap = [];
  resultMap = [...urlpath.matchAll(/(?<=^(\/(.*)?)(?=\/|\?))/g)].map((match) => {
    const item = match[1];
    if (!item) {
      return defaultPath;
    }
    const names = match[2].split("/");
    return {
      path: item,
      name: localLookup && localLookup.get(names[names.length - 1]) || globalLookup && globalLookup.get(names[names.length - 1]) || names[names.length - 1] || defaultPath.name
    };
  });
  return [...urlList, ...resultMap];
};
var RoutedBreadcrumb = (_a) => {
  var _b = _a, {
    url = window.location.pathname,
    globalLookup = /* @__PURE__ */ new Map(),
    localLookup = /* @__PURE__ */ new Map(),
    homeBreadcrumbLabel = "home"
  } = _b, restProps = __objRest(_b, [
    "url",
    "globalLookup",
    "localLookup",
    "homeBreadcrumbLabel"
  ]);
  const urlList = parseURLRoute(url, globalLookup, localLookup, homeBreadcrumbLabel);
  return /* @__PURE__ */ React.createElement(MinBreadcrumbs, __spreadValues({
    "aria-label": "breadcrumbs"
  }, restProps), urlList.map((url2, index) => {
    return index < urlList.length - 1 ? /* @__PURE__ */ React.createElement(Link, {
      key: url2.path,
      href: url2.path,
      sx: { textTransform: "capitalize" }
    }, url2.name) : /* @__PURE__ */ React.createElement("span", {
      key: url2.path,
      style: { textTransform: "capitalize" }
    }, url2.name);
  }));
};
export {
  RoutedBreadcrumb
};
